import { UseFormReturn } from 'react-hook-form';
import LoungeDateIformaton from '../LoungeDateIformaton';
import { LoungeResource } from '../../../../store/lounges/loungesManagementTypes';

type PropsTypes = {
  originalArray: number[];
  form: UseFormReturn<any, object>;
  lounge: LoungeResource;
};

const BookLoungeForm = (props: PropsTypes) => {
  return (
    <div className="book-lounge-form-content">
      <div className="book-lounge-form">
        <LoungeDateIformaton
          form={props.form}
          lounge={props.lounge}
          originalArray={props.originalArray}
        />
      </div>
    </div>
  );
};

export default BookLoungeForm;
